module.exports = __webpack_public_path__ + "static/media/TRIAL 3.e8d5a389.mp3";